// Temporary local UI review (menus and actions). Set false to restore permissions.
export const MENU_PREVIEW_ENABLED = false;

export const isMenuPreviewEnabled = () =>
    MENU_PREVIEW_ENABLED &&
    process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
